import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isNil } from 'lodash';
import { commentBoxEventsBus, COMMENT_BOX_FOCUS_EVENT } from '../CommentsBox';
import MediaViewerElementShape from '../../../MediaViewer/PropsShape/MediaViewerElementShape';
import { COMMENT_CLICK_EVENT, commentEventsBus } from '../../eventsBus/comment';
import { MEDIA_PLAY_EVENT, MARKER_CLICK_EVENT, OVERLAY_CLICK_EVENT, PROGRESS_CLICK_EVENT } from '../../../MediaViewer/consts';
import { collaborationEventBus } from '../../../Utils';
import * as CurrentsAction from '../../actions/current';

class MediaController extends Component {
    constructor(props) {
        super(props);

        this.onCommentBoxFocus = this.onCommentBoxFocus.bind(this);
        this.onProgressClick = this.onProgressClick.bind(this);
        this.onCommentClick = this.onCommentClick.bind(this);
        this.pauseMedia = this.pauseMedia.bind(this);
        this.onPlay = this.onPlay.bind(this);
    }

    componentDidMount() {
        commentBoxEventsBus.on(COMMENT_BOX_FOCUS_EVENT, this.onCommentBoxFocus);
        commentEventsBus.on(COMMENT_CLICK_EVENT, this.onCommentClick);
        collaborationEventBus.on(MARKER_CLICK_EVENT, this.onCommentClick);
        collaborationEventBus.on(MEDIA_PLAY_EVENT, this.onPlay);
        collaborationEventBus.on(OVERLAY_CLICK_EVENT, this.pauseMedia);
        collaborationEventBus.on(PROGRESS_CLICK_EVENT, this.onProgressClick);
    }

    onPlay() {
        this.props.setCurrentCommentId(undefined);
    }

    onProgressClick() {
        this.props.setCurrentCommentId(undefined);
    }

    pauseMedia() {
        const { media } = this.props;
        const pauseApi = get(media, 'api.pause');
        pauseApi && pauseApi();
    }

    updateCurrentTime() {
        const { media, setCurrentTimecode } = this.props;
        const currentTimeApi = get(media, 'api.currentTime');
        const currentTime = (currentTimeApi && currentTimeApi()) || 0;
        setCurrentTimecode && setCurrentTimecode(currentTime);
    }

    seekMedia(time) {
        const { media } = this.props;
        const seekApi = get(media, 'api.seek');
        !isNil(time) && seekApi && seekApi(time);
    }

    onCommentClick(payload = {}) {
        this.pauseMedia();
        this.seekMedia(payload.timecode);
        this.updateCurrentTime();
    }

    onCommentBoxFocus() {
        this.pauseMedia();
        this.updateCurrentTime();
    }

    render() {
        return null;
    }
}

MediaController.propTypes = {
    media: MediaViewerElementShape,
    setCurrentTimecode: PropTypes.func,
    setCurrentCommentId: PropTypes.func
};

export default connect(null, { setCurrentTimecode: CurrentsAction.setCurrentTimecode, setCurrentCommentId: CurrentsAction.setCurrentCommentId })(MediaController);
